import React, { useEffect } from 'react'

import { useGeneralParams } from '../../../../hooks/useDataPaginate'
import { CreateValues, DeleteValues, UpdateValues } from '../../../../FormSchemes/RolScheme'
import { MinimalActionButton } from '../../../../components/form/minimalActionButton'
import { requestAuth } from '../../../../http/httpRequest'
import { loginOn, loginOut, removeToken, saveUserDetail } from '../../../../store/slices/auth'
import { DefaultParamsForRecall } from '../../../../utils/defaulStates'
import { useSelector } from 'react-redux'
import { Callers } from '../../../../hooks/Callers'

export const ListRolTable = () => {
    const {
        dispatch,
        data, setData,
        paginate, setPaginate,
        selectedDay, setSelectedDay,
        selecteds, setSelecteds,
        selectAllChecked, setSelectAllChecked,
        isChecked, setIsChecked,
        stateData, setStateData,
        createModal, setCreateModal,
        updateModal, setUpdateModal,
        deleteModal, setDeleteModal,
        currentData, setCurrentData,
        // imports
        requestAuthPaginate,
        TableContainer,
        Paginator,
        // formatFilters,
        Searcher,
        // FilterSelect,
        // RangeDate,
        Actions,
        TableSection,
        ActionSection,
        Section,
        ModalForm,
        UpdateValuesModal,
        navigate
    } = useGeneralParams()
    const reloadMainTable = useSelector(state => state.login.reloadMainTable)
    const getDataPaginate = async () => {
        await requestAuthPaginate({
            method: 'get',
            url: `/roles/pag`,
            data: null,
            queries: paginate,
            setData: setData,
            setStateData: setStateData,
            setQueries: setPaginate,
            dispatch: dispatch,
            aditionalParams: { filterBy: 'nombre' }
        })
    }
    useEffect(() => {
        getDataPaginate();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), reloadMainTable]);

    // useEffect(() => {
    //     console.log(selecteds)
    // }, [selecteds]);

    useEffect(() => {
        setSelectAllChecked(false)
        setIsChecked(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), reloadMainTable]);

    const reloadTable = () => {
        Callers(dispatch)
        setSelectAllChecked(false)
        setIsChecked(false)
        setSelecteds([])
    }
    const updateRecall = async () => {
        getDataPaginate()

        await requestAuth(
            'get',
            `/user/Detail`,
            null
        )
            .then((response) => {
                dispatch(loginOn())
                dispatch(saveUserDetail(response.data))
            }
            )
            .catch(() => {
                dispatch(loginOut())
                dispatch(removeToken())
                navigate('/login')
                dispatch(saveUserDetail(null))
                localStorage.removeItem('token')
            })
    }
    return (
        <Section>
            <ActionSection>
                <Actions
                    buttons={[
                        {
                            icon: 'add',
                            label: 'Crear',
                            action: () => setCreateModal(true)
                        },
                    ]}
                />
                <Searcher
                    paginate={paginate}
                    setPaginate={setPaginate}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    options={[
                        {
                            label: 'Nombre',
                            value: 'nombre'
                        },
                    ]}
                    reloadTable={reloadTable}
                />
                <div className='flex gap-2 flex-wrap'>
                    {/* <RangeDate
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        paginate={paginate}
                        setPaginate={setPaginate}
                    /> */}
                    {/* <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='estado'
                        options={[
                            {
                                label: 'Estado',
                                value: ''
                            },
                            {
                                label: 'Activo',
                                value: 'activo'
                            },
                            {
                                label: 'Inactivo',
                                value: 'inactivo'
                            }
                        ]}
                    /> */}
                    <MinimalActionButton
                        icon='repeat'
                        label=''
                        action={reloadTable}
                    />
                </div>
            </ActionSection>
            <TableSection
                stateData={stateData}
                paginator={Paginator}
                data={data}
            >
                <TableContainer
                    headers={[
                        {
                            label: 'Nombre',
                            columns: ['etiqueta']
                        },
                        {
                            label: 'Permitir cuaderno',
                            columns: ['permitir_cuaderno'],
                            boolean: true,
                            booleanOptions: ['Permitir', 'Denegar'],
                            booleanIconTrue: 'fa-check',
                            booleanIconFalse: 'fa-xmark'
                        },
                        {
                            label: 'Permitir almacén',
                            columns: ['permitir_almacen'],
                            boolean: true,
                            booleanOptions: ['Permitir', 'Denegar'],
                            booleanIconTrue: 'fa-check',
                            booleanIconFalse: 'fa-xmark'
                        },
                        {
                            label: 'Empleado',
                            columns: ['empleado'],
                            boolean: true,
                            booleanOptions: ['Si', 'No'],
                            booleanIconTrue: 'fa-check',
                            booleanIconFalse: 'fa-xmark'
                        },
                        {
                            label: 'Responsable de vehiculo',
                            columns: ['responsable_vehiculo'],
                            boolean: true,
                            booleanOptions: ['Si', 'No'],
                            booleanIconTrue: 'fa-check',
                            booleanIconFalse: 'fa-xmark'
                        },
                        {
                            label: 'Limitar permisos',
                            columns: ['limitar_permisos'],
                            boolean: true,
                            booleanOptions: ['Si', 'No'],
                            booleanIconTrue: 'fa-check',
                            booleanIconFalse: 'fa-xmark'
                        },
                        {
                            label: 'Acciones',
                            actions: [
                                {
                                    type: 'edit',
                                    icon: 'fa-edit',
                                    action: (data) => UpdateValuesModal(data, setCurrentData, setUpdateModal),
                                },
                                {
                                    type: 'delete',
                                    icon: 'fa-trash',
                                    action: (data) => UpdateValuesModal(data, setCurrentData, setDeleteModal),
                                    reference: 'id'
                                }
                            ],
                            // stickyR: true
                        },
                    ]}
                    data={data.data}
                    checkList={false}
                    selecteds={selecteds}
                    setSelecteds={setSelecteds}
                    selectAllChecked={selectAllChecked}
                    setSelectAllChecked={setSelectAllChecked}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    stateData={stateData}
                />
            </TableSection>
            {
                createModal &&
                <ModalForm
                    setModal={setCreateModal}
                    label='Crear rol'
                    dataValues={CreateValues()}
                    urlApi={'/rol'}
                    method={'post'}
                    call={reloadTable}
                    buttonLabel='Registrar'
                />
            }
            {
                updateModal &&
                <ModalForm
                    setModal={setUpdateModal}
                    label='Editar rol'
                    dataValues={UpdateValues(currentData)}
                    urlApi={'/rol'}
                    method={'put'}
                    call={updateRecall}
                    buttonLabel='Editar'
                />
            }
            {
                deleteModal &&
                <ModalForm
                    setModal={setDeleteModal}
                    label='Eliminar rol'
                    dataValues={DeleteValues(currentData)}
                    urlApi={`/rol/${currentData.id}`}
                    method={'delete'}
                    call={reloadTable}
                    buttonLabel='Eliminar'
                />
            }
        </Section>
    )
}